import _ from "lodash";

export const MARKETING_DASHBOARD_TABS_LIST = [
    {key: 'facebook', label: 'Facebook'},
    {key: 'media', label: 'Media'},
    // {key: 'selected-products', label: 'Selected Products'},
];

export const DEFAULT_MARKETING_DASHBOARD_TAB = {key: 'facebook', label: 'Facebook'};
// export const DEFAULT_MARKETING_DASHBOARD_TAB = {key: 'media', label: 'Media'};
// export const DEFAULT_MARKETING_DASHBOARD_TAB = {key: 'selected-products', label: 'Selected Products'};
